import styled, { css } from 'styled-components';
import CloseWhite from 'images/common-function/close-white.png';

export const Wrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  width: 700px;
  max-width: 100%;
  height: calc(100% - 140px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.8);
`;

export const Header = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  background-color: #ed2026;
  position: relative;
  padding: 0 20px;
  > h2 {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  :before {
    content: '';
    display: block;
    width: 18px;
    height: 18px;
    background: url(${CloseWhite}) no-repeat center center;
    background-size: 17px;
  }
`;

export const Input = styled.input`
  padding: 0 20px;
  width: 100%;
  height: 47px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  margin: 20px 0 15px;
`;

export const ContentWrap = styled.div`
  padding: 0 30px;
  height: calc(100% - 135px);
  .ck-editor {
    height: calc(100% - 97px);
    .ck-editor__main {
      height: calc(100% - 38.67px - 1rem);
      .ck-content {
        height: 100%;
      }
    }
  }
  .content {
    width: 100% !important;
    box-sizing: border-box;
  }
`;

export const ButtonsWrap = styled.div`
  padding: 0 30px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  > p {
    color: #333;
  }
`;

export const Button = styled.button`
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  &.cancel {
    color: #333;
    background-color: #fff;
    border: 1px solid #c4c4c4;
    margin-left: auto;
  }
  &.submit {
    color: #fff;
    background-color: #ed2026;
    margin-left: 14px;
  }
`;

export const AuthorSelectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1rem;
`;
